import React from 'react';
import {type BootStrapProps} from '../../Bootstrap';
import {Form, type FormGroupProps} from 'react-bootstrap';
import {type ColProps} from 'react-bootstrap/Col';

export type BootStrapFormGroupProps = BootStrapProps<FormGroupProps> & ColProps;

export const BootstrapFormGroup = (props: BootStrapFormGroupProps) => <Form.Group {...props as any} className={'mb-3 ' + (props.className ?? '')} />;
